import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Container from '../Container';
import EmptyButton from '../EmptyButton';
import CloseIcon from '../../images/CloseIcon';

const Tag = forwardRef(({ children, selected, onRemove, ...props }, ref) => (
  <Container
    ref={ref}
    borderRadius="30px"
    border={
      selected ? `1px solid rgba(151, 174, 255, 0.5)` : `1px solid #ececec`
    }
    color={selected ? 'primary' : 'normal'}
    backgroundColor={selected ? '#eaefff' : 'white'}
    padding={onRemove ? '4px 5px 4px 10px' : '4px 10px'}
    fontWeight="600"
    fontSize="14px"
    display="flex"
    alignItems="center"
    minHeight="32px"
    margin="3px"
    {...props}
  >
    {children}
    {!!onRemove && (
      <EmptyButton
        onClick={onRemove}
        flex="0 0 22px"
        width="22px"
        height="22px"
        backgroundColor={selected ? 'white' : 'background300'}
        borderRadius="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        marginLeft="5px"
      >
        <CloseIcon
          width="9px"
          height="9px"
          fill={theme =>
            `${selected ? theme.background.primary : theme.text.normal}`
          }
        />
      </EmptyButton>
    )}
  </Container>
));

Tag.propTypes = {
  children: PropTypes.node,
  selected: PropTypes.bool,
  onRemove: PropTypes.func,
};

Tag.defaultProps = {
  children: null,
  selected: false,
  onRemove: null,
};

export default Tag;
